(function(DataLayer) {
    DataLayer.cookies = (event)=>DataLayer.DatalayerApi.push({
            event: `Cookies: ${event}`
        });
    (function(DatalayerApi) {
        DatalayerApi.getDatalayer = ()=>window['dataLayer'] ? window['dataLayer'] : undefined;
        DatalayerApi.push = (data)=>{
            const datalayer = DatalayerApi.getDatalayer();
            if (datalayer) {
                datalayer.push(data);
            } else {
                console.log('DataLayer not found, failed to push event', data);
            }
        };
    })(DataLayer.DatalayerApi || (DataLayer.DatalayerApi = {}));
})(DataLayer || (DataLayer = {}));
export var DataLayer;
